import React from 'react';
import { useParams } from 'react-router-dom';

import { Header, Tabs, TenantIcon } from '../CommonComponents';
import { Container } from '../StyledComponents';
import TenantDetails from './TenantDetails';
import TenantUsers from './TenantUsers';
import TenantGroups from './TenantGroups';
import TenantOffers from './TenantOffers';
import TenantOrders from './TenantOrders';
import FetchRedux from '../CommonComponents/Fetch/FetchRedux';
import { FetchPropsType } from '../CommonComponents/Fetch/FetchPropsType';
import { fetchTenantMetaById, selectFetchingTenantMetaById, selectTenantMetaById } from '../../redux/actions/tenants';
import TenantRequests from './TenantRequests';
import TenantArticles from './TenantArticles';
import TenantUpdateBanner from './TenantUpdateBanner';

const renderTenantIcon = (
    { isCarrier, activeSubscription, subscriptionEndDate }:
        { isCarrier: boolean, activeSubscription: boolean, subscriptionEndDate: string | null }
) => ({
    icon: <TenantIcon
        isCarrier={isCarrier}
        activeSubscription={activeSubscription}
        subscriptionEndDate={subscriptionEndDate}
        badgeSize={20}
        top={0}
        right={35}
        carrierSx={{ height: 38, width: 38 }}
        nonCarrierSx={{ height: 36, width: 36 }}
    />,
    top: isCarrier ? '2px' : '-1px'
});

const tabs = [{
    key: 'tenant',
    label: 'Uppgifter',
    Component: TenantDetails,
    padding: 2
}, {
    key: 'users',
    label: 'Användare',
    Component: TenantUsers
}, {
    key: 'groups',
    label: 'Grupper',
    Component: TenantGroups
}, {
    key: 'orders',
    label: 'Uppdrag',
    Component: TenantOrders
}, {
    key: 'offers',
    label: 'Anbud',
    Component: TenantOffers
}, {
    key: 'requests',
    label: 'Aktiviteter',
    Component: TenantRequests
}, {
    key: 'articles',
    label: 'Artiklar',
    Component: TenantArticles
}];

type TenantMetaType = {
    [key: string]: number | string | boolean | string[] | null,
    // name: string,
    // usersCount: number,
    // groupsCount: number,
    // ordersCount: number,
    // offersCount: number
};

function TenantTabs(props: FetchPropsType<TenantMetaType>) {
    const { entity, fetch } = props;

    const getTitle = React.useCallback((tab) => {
        if (!entity) {
            return tab.label;
        }
        const count = entity[`${tab.key}Count` as string];
        return typeof count === 'number'
            ? `${tab.label} (${count})`
            : tab.label;
    }, [entity]);

    return (
        <Container>
            <Header
                titleIcon={renderTenantIcon({
                    isCarrier: entity.isCarrier as boolean,
                    activeSubscription: entity.activeSubscription as boolean,
                    subscriptionEndDate: entity.subscriptionEndDate as string | null
                })}
                title={entity.name as string ?? 'Företag'}
                subtitle={entity.orgNumber as string}
            />
            {entity.latestUpdateAt && (
                <TenantUpdateBanner
                    tenantId={entity.id as number}
                    updatedAt={entity.latestUpdateAt as string}
                    updatedByName={entity.latestUpdateByName as string | null}
                    sources={entity.pendingUpdateSources as string[] | null}
                    onModerated={fetch}
                />
            )}
            <Tabs
                tabsKey="tenants"
                tabs={tabs}
                getTitle={getTitle}
            />
        </Container>
    );
}

export default function TenantTabsFetched() {
    const { id } = useParams() as unknown as { id: number };

    return (
        <FetchRedux<TenantMetaType>
            fetchEntity={fetchTenantMetaById(id)}
            selectEntity={selectTenantMetaById(id)}
            selectIsFetching={selectFetchingTenantMetaById(id)}
            Component={TenantTabs}
            name="företaget"
        />
    );
}
